/*
 * Copyright (C) 2026 Discorch Contributors
 *
 * This file is part of Discorch.
 *
 * Discorch is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Discorch is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Discorch. If not, see <https://www.gnu.org/licenses/>.
 */

import { Checkbox } from "@/components/ui/checkbox";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

interface CheckboxWithStateProps {
  checked: boolean;
  indeterminate?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

export const CheckboxWithState = React.forwardRef<
  HTMLButtonElement,
  CheckboxWithStateProps
>(
  (
    {
      checked,
      indeterminate,
      onCheckedChange,
      onClick,
      disabled,
      className,
      "aria-label": ariaLabel,
    },
    ref,
  ) => {
    let checkboxState: CheckboxPrimitive.CheckedState = false;
    if (indeterminate) {
      checkboxState = "indeterminate";
    } else if (checked) {
      checkboxState = true;
    }

    return (
      <Checkbox
        ref={ref}
        checked={checkboxState}
        onCheckedChange={onCheckedChange}
        onClick={onClick}
        disabled={disabled}
        className={className}
        aria-label={ariaLabel}
      />
    );
  },
);

CheckboxWithState.displayName = "CheckboxWithState";
